import { useTranslation } from 'next-i18next';
import React, { useCallback } from 'react';
import TooltipComponent from 'src/ui/common/organisms/tooltip/tooltip.component';
import { useTabsContext } from './tabs.provider';
import { StyledItemsContainer, StyledTabItem } from './tabs.styles';
import { ITabItem, ITabItems } from './tabs.types';

export const TabItem = ({ tabId, disabled, comingSoon, tab }: ITabItem) => {
    const { selectedTabId, handleSelectTab } = useTabsContext();
    const { t } = useTranslation('common');

    const onTabClick = useCallback(() => {
        handleSelectTab(tabId);
    }, [handleSelectTab, tabId]);

    return (
        <StyledTabItem
            data-component="tab-item"
            data-component-id={`tab-item-${tabId}`}
            disabled={disabled}
            isSelected={selectedTabId === tabId}
            onClick={disabled ? undefined : onTabClick}
        >
            {comingSoon ? (
                <TooltipComponent position="bottom-start" isFloating content={t('messages.comingSoon')}>
                    <span>{tab}</span>
                </TooltipComponent>
            ) : (
                tab
            )}
        </StyledTabItem>
    );
};

export const TabItems = ({ tabItems }: ITabItems) => (
    <StyledItemsContainer alignItems="center">
        {tabItems.map(({ tab, comingSoon, disabled, tabId }) => (
            <TabItem tabId={tabId} key={tabId} disabled={disabled} tab={tab} comingSoon={comingSoon} />
        ))}
    </StyledItemsContainer>
);
